(function () {
  'use strict';

  // ---- Config (matches your popup DOM) ----
  const POPUP_BODY_SEL = '.lb-popup-cont-body';     // container holding <lb-addon>
  const AREA_INPUT_SEL = '.m2-input-section input'; // the m² input

  // Format helper
  const fmt2 = n => Number.isFinite(+n) ? (+n).toFixed(2) : '0.00';

  // Read area once
  function getArea() {
    const inp = document.querySelector(AREA_INPUT_SEL);
    if (!inp) return 0;
    const v = parseFloat(String(inp.value || '').replace(',', '.'));
    return Number.isFinite(v) && v >= 0 ? v : 0;
  }

  // Inject the two recommendation lines before <lb-addon>
  function insertBannerOnce(body) {
    if (!body || body.querySelector('#wot-upsell-reco')) return;

    const area = getArea();
    const adhesiveKg = fmt2(area * 4);   // adhesive total kg
    const groutKg    = fmt2(area * 0.4); // grout total kg

    const banner = document.createElement('div');
    banner.id = 'wot-upsell-reco';
    banner.style.margin = '12px 0';
    banner.style.padding = '10px 12px';
    banner.style.border = '1px solid #e4e7ec';
    banner.style.borderRadius = '6px';
    banner.style.fontSize = '14px';
    banner.style.lineHeight = '1.35';
    banner.innerHTML =
      `<p style="margin:0 0 6px 0;">For the area you are tiling we recommend <strong>${adhesiveKg} kg</strong> of adhesive.</p>` +
      `<p style="margin:0;">For the area you are tiling we recommend <strong>${groutKg} kg</strong> of grout.</p>`;

    const addon = body.querySelector('lb-addon');
    if (addon && addon.parentNode === body) {
      body.insertBefore(banner, addon);
    } else {
      body.insertBefore(banner, body.firstChild);
    }
  }

  // ---- No listeners: simple, finite polling until popup exists, then stop ----
  function boot() {
    let tries = 0;
    const maxTries = 50;     // ~10s if interval is 200ms
    const iv = setInterval(() => {
      tries++;
      const body = document.querySelector(POPUP_BODY_SEL);
      if (body) {
        // insertBannerOnce(body);
        clearInterval(iv);  // done
      } else if (tries >= maxTries) {
        clearInterval(iv);  // give up quietly
      }
    }, 200);
  }

  // Run after DOM is parsed (still no event handlers attached to your inputs)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
